import { render, staticRenderFns } from "./RelationDialog.vue?vue&type=template&id=b9987c9a&"
import script from "./RelationDialog.vue?vue&type=script&lang=js&"
export * from "./RelationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports